import { Close } from '@radix-ui/react-dialog'

export const DialogClose = Close
